const rootArea = "/exports";

export const exportsGlob = (exportConfiguration: string) => ({
	read: `${rootArea}/${exportConfiguration}/read`,
	create: `${rootArea}/${exportConfiguration}/create`,
	logs: (exportLogId: string) => ({
		read: `${rootArea}/${exportConfiguration}/logs/${exportLogId}/read`
	})
});
